import { defineSlotRecipe } from "@pandacss/dev";
import { progressAnatomy } from "@ark-ui/react";

export const aromaLoaderCircle = defineSlotRecipe({
  className: "aroma-loader-circle",
  jsx: ["LoaderCircle"],
  slots: [...progressAnatomy.keys(), "dot"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "gap.2",
    },
    circle: {
      position: "relative",
      transformOrigin: "center center",
      animation: "rotateCircle 2s linear(0 0%, 0.5 50%, 1 100%) infinite",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    dot: {
      fill: "border.neutral.bolder",
    },
    label: {
      textStyle: "paragraph.m.regular",
      color: "content.neutral.base.subtlest",
      fontSize: "fontSizes.88",
    },
  },
  variants: {
    size: {
      small: {
        root: {
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "row",
        },
        circle: {
          "--size": "{sizes.xs}",
        },
      },
      medium: {
        circle: {
          "--size": "{sizes.m}",
        },
      },
      large: {
        circle: {
          "--size": "{sizes.2xl}",
        },
      },
    },
    type: {
      brand: {
        dot: {
          fill: "background.brand.bold",
        },
      },
      neutral: {},
      reverse: {
        dot: {
          fill: "border.neutral.subtlest",
        },
        label: {
          color: "content.neutral.reverse.bold",
        },
      },
      error: {
        dot: {
          fill: "border.functional.error",
        },
        label: {
          color: "content.functional.error",
        },
      },
    },
  },
});
